/** Articles → "Site & domain" page test ids — mirrored in @test-kit ARTICLE (keep in sync). */
export const ARTICLE_SITE_PAGE_TEST_ID = 'article-site-page';
/** Toolbar button on the Articles list that opens "Site & domain" (ARTICLE.SITE_DOMAIN_BUTTON). */
export const ARTICLE_SITE_DOMAIN_BUTTON_TEST_ID = 'articles-site-domain-button';
/** "Article domain" section of the page (the path-mode section is added by the path-mode panel task). */
export const ARTICLE_SITE_DOMAIN_SECTION_TEST_ID = 'articles-site-domain';
